export function setBannersLoading (state, loading = false) {
  state.bannersLoading = loading
}

export function setBanners (state, banners) {
  state.banners = banners.data
  state.bannersCurrentPage = banners.current_page
  state.bannersLastPage = banners.last_page
  state.bannersPerPage = banners.per_page
  state.bannersTotal = banners.total
  state.bannersActiveTotal = banners.total_active
}

export function setIndexPage (state, page = null) {
  state.indexPage = page
}
